exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, ".countriesList__3tBLaoeEK4 {\n  -webkit-box-flex: 1;\n          flex: 1 1 auto;\n}\n", "",{"version":3,"sources":["OfficePageCountries.scss"],"names":[],"mappings":"AAAA;EACE,mBAAc;UAAd,cAAc;AAChB","file":"OfficePageCountries.scss","sourcesContent":[".countriesList {\n  flex: 1 1 auto;\n}\n"]}]);
// Exports
exports.locals = {
	"countriesList": "countriesList__3tBLaoeEK4"
};